import { Column } from '@access-erp/common';
import { useMemo } from 'react';

import { goToRouteBySearch } from '@/components/common/EnquiriesScreen/utils/goToRouteBySearch';
import { useGetredirectLink } from '@/components/common/EnquiriesScreen/utils/useGetRedirectLink';
import { getHeaderColumns } from '../columns/headerColumns';
import { browserHistory } from '@/routing/browserHistory';
import { getParameterizedLink } from '@/utils/getLinkWithSubscriptionId.utils';
import { contractsBCPath } from '@/utils/path.utlis';

export interface UseTransactionTableColumnsReturn {
  headerColumns: Column<unknown>[];
  goToBundlesBySearch: (searchText?: string) => void;
}

export const useColumns = (): UseTransactionTableColumnsReturn => {
  const getRedirectLink = useGetredirectLink();

  const getContractLink = (contractId: string, searchString?: string) => {
    let link = getRedirectLink(window.location.pathname, contractId, searchString);
    link = link.replace('/bundles/', `/${contractsBCPath}/`);
    return getParameterizedLink(link);
  };

  const goToContract = (contractLink: string) => {
    browserHistory.push(getParameterizedLink(contractLink));
  };

  const goToBundlesBySearch = (searchText?: string) => {
    goToRouteBySearch(searchText);
  };

  return useMemo(() => {
    const headerColumns = getHeaderColumns({ getContractLink, goToContract });
    return {
      headerColumns,
      goToBundlesBySearch,
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
